import { queryOptions } from '@tanstack/react-query';
import { cepService } from './services/cepService';
import { formularioService } from './services/formularioService';

export const formularioQueries = {
  all: () => ['formulario'] as const,
  ativa: () =>
    queryOptions({
      queryKey: [...formularioQueries.all(), 'ativa'] as const,
      queryFn: () => formularioService.campanhaAtiva(),
      retry: false,
    }),
  participacao: (id: string) =>
    queryOptions({
      queryKey: [...formularioQueries.all(), 'participacao', id] as const,
      queryFn: () => formularioService.participacao(id),
      retry: false,
      staleTime: 0, // spec 20 R6b: a pessoa vê o estado atual ao abrir
      // O formulário remonta quando a versão muda: refetch ao focar a janela não pode trocar dados sob a pessoa.
      refetchOnWindowFocus: false,
    }),
  paises: () =>
    queryOptions({
      queryKey: [...formularioQueries.all(), 'paises'] as const,
      queryFn: () => formularioService.paises(),
      staleTime: 3_600_000,
      retry: false,
    }),
  estados: () =>
    queryOptions({
      queryKey: [...formularioQueries.all(), 'estados'] as const,
      queryFn: () => formularioService.estados(),
      staleTime: 3_600_000,
      retry: false,
    }),
  cidades: (estadoId: number) =>
    queryOptions({
      queryKey: [...formularioQueries.all(), 'cidades', estadoId] as const,
      queryFn: () => formularioService.cidades(estadoId),
      staleTime: 3_600_000,
      retry: false,
    }),
};

export const cepQueries = {
  porCep: (cep: string) =>
    queryOptions({
      queryKey: ['formulario', 'cep', cep] as const,
      queryFn: () => cepService.consultar(cep),
      staleTime: 3_600_000,
      retry: false,
    }),
};
